export default "__VITE_ASSET__5GS__IH___"